
import { SectionWithIconParagraphProps } from './query';
import Button_v2 from '@/components/molecules/Button/index';
import Paragraph from '@/components/molecules/Paragraph';
import Title_v2 from '@/components/molecules/Title/index';
import { renderUnderline } from '@/utilities/functions';

const SectionWithIconParagraph = ({ sectionIconParagraphData }: { sectionIconParagraphData: SectionWithIconParagraphProps }) => {

	return (
		<>
			{sectionIconParagraphData.iconParagraphSectionTitle && (
				<Title_v2
					align={sectionIconParagraphData.iconParagraphSectionTitle.alignedAt}
					underlineColor={sectionIconParagraphData.iconParagraphSectionTitle.underlineColor}
				>
					{renderUnderline(sectionIconParagraphData.iconParagraphSectionTitle.titlePieces)}
				</Title_v2>
			)}
			{sectionIconParagraphData.paragraph.map(
				(paragraph, index) => (
					<Paragraph paragraph={paragraph} key={index} />
				),
			)}
			{
				sectionIconParagraphData.buttons && (
					sectionIconParagraphData.buttons.map(
						(button, index) => (
							<Button_v2
								gtm_id={button.trackerId}
								href={button.url}
								key={index}
								openOnNewTab={button.newTab}
								text={button.text}
								version={button.variant}
							/>
						),
					)
				)
			}
		</>
	);
};

export default SectionWithIconParagraph;
